export interface TryonResource {
  pose: number
  url: string
}
export interface ApiResponse<T> {
  result?: T
  errorCode?: string
  errorMessage?: string
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const API_URL_PROD = 'https://open.topology-engineering.com'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const API_URL_QA = 'https://open-qa.topology-engineering.com'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const API_KEY_PROD = '56NPKrOM8f8qwsPw5MIUJ3pszxooG1Gh8CT9x7AJ'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const API_KEY_QA = 'om7e9fMgQE3daJEx9idXO7txd40WVDssatDdyIFG'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const ON_DEMAND_URL_PROD = 'https://vto-render-us.topology-engineering.com'

const APIClient = {
  async tryOnV0(vtoEnv: string, route: string): Promise<ApiResponse<TryonResource[]>> {
    const url = `${this.apiUrl(vtoEnv)}/tryon/assets`
    const response = await fetch(url, {
      headers: {
        'x-api-key': this.apiKey(vtoEnv),
        route,
        'Content-Type': 'application/json'
      },
      mode: 'cors'
    })
    const json = await response.json()

    if (json.hasOwnProperty('code') || json.hasOwnProperty('message')) {
      return {
        errorCode: json?.code,
        errorMessage: json?.message
      }
    } else {
      return {
        result: json
      }
    }
  },

  async tryOnV1(vtoEnv: string, route: string): Promise<ApiResponse<string>> {
    try {
      const url = `${ON_DEMAND_URL_PROD}/render?route=${encodeURIComponent(route)}`
      const response = await fetch(url, { mode: 'cors' })

      if (response.ok) {
        const rawData = await response.blob()

        return {
          result: URL.createObjectURL(rawData)
        }
      } else {
        const json = await response.json()

        switch (json.code) {
          case 'PRODUCT_NOT_FITTING':
            return {
              errorCode: '',
              errorMessage: 'errNotFitting'
            }
          case 'SCAN_NOT_FOUND':
          case 'SCAN_UNABLE_TO_DOWNLOAD':
          case 'SCAN_NOT_VALID':
          case 'SCAN_NOT_AVAILABLE':
            return {
              errorCode: json.code,
              errorMessage: 'errInvalidScan'
            }
          default:
            return {
              errorCode: json.code || '',
              errorMessage: 'errGeneric'
            }
        }
      }
    } catch (e) {
      console.log(e)

      return {
        errorCode: '',
        errorMessage: 'errGeneric'
      }
    }
  },

  apiUrl(vtoEnv: string): string {
    return vtoEnv === 'prod' ? API_URL_PROD : API_URL_QA
  },

  apiKey(vtoEnv: string): string {
    return vtoEnv === 'prod' ? API_KEY_PROD : API_KEY_QA
  }
}

export default APIClient
